import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const BASE_URL = 'https://newalemny.3almny.app/api';

// بدء الواجب (للطلاب فقط)
export const startDutySession = createAsyncThunk(
  'dutySession/startDutySession',
  async (lessonId, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('token3almny');
      if (!token) {
        return rejectWithValue('التوكن مطلوب');
      }
      const response = await fetch(`${BASE_URL}/duties/student_enter_duty/${lessonId}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      if (!response.ok) {
        return rejectWithValue(data.message || 'فشل بدء الواجب');
      }
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'فشل بدء الواجب');
    }
  }
);

// إرسال إجابات الواجب
export const submitDutyAnswers = createAsyncThunk(
  'dutySession/submitDutyAnswers',
  async ({ lessonId, answers }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('token3almny');
      if (!token) {
        return rejectWithValue('التوكن مطلوب');
      }
      const response = await fetch(`${BASE_URL}/duties/submit_duty/${lessonId}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ answers }),
      });
      const data = await response.json();
      if (!response.ok) {
        return rejectWithValue(data.message || 'فشل إرسال إجابات الواجب');
      }
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'فشل إرسال إجابات الواجب');
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  started: false,
  submitResult: null,
};

const dutySessionSlice = createSlice({
  name: 'dutySession',
  initialState,
  reducers: {
    clearDutySession: (state) => {
      state.loading = false;
      state.error = null;
      state.started = false;
      state.submitResult = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(startDutySession.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(startDutySession.fulfilled, (state, action) => {
        state.loading = false;
        // يعتبر البدء ناجحاً إذا كانت النتيجة موجودة أو success = true
        const payload = action.payload || {};
        state.started = !!(payload.result || payload.success === true || payload.status === true);
      })
      .addCase(startDutySession.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(submitDutyAnswers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(submitDutyAnswers.fulfilled, (state, action) => {
        state.loading = false;
        state.submitResult = action.payload?.result ?? action.payload;
      })
      .addCase(submitDutyAnswers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearDutySession } = dutySessionSlice.actions;
export default dutySessionSlice.reducer;


